import { da } from 'date-fns/locale';
import { forwardRef, useRef } from 'react';
import ReactDatePicker from 'react-datepicker';
import { DatePickerProps } from '../DatePicker';
import { DatePickerCustomHeader } from '../DatePicker/DatePickerCustomHeader/DatePickerCustomHeader';
import { DatePickerInput } from '../DatePicker/DatePickerInput/DatePickerInput';
import '../DatePicker/ReactDatePicker.css';

export interface DateRangePickerProps extends Omit<DatePickerProps, 'callBack'> {
	callBack: (dates: Date[]) => void;
}

const CustomInput = forwardRef(function CustomInput(props: any, customRef) {
	return <DatePickerInput {...props} innerRef={customRef} />;
});

export const DateRangePicker = ({ id, placeholder, ariaLabels, language = 'da', callBack, startDate, endDate, ...props }: DateRangePickerProps) => {
	const { enableMonthSelect, enableYearSelect, yearOptions } = props ?? {};
	const inputRef = useRef(null);

	const onChange = (dates: Date[]) => {
		callBack && callBack(dates);
	};

	return (
		<ReactDatePicker
			id={'range-date-picker-identifier_' + id}
			selected={startDate}
			renderCustomHeader={(headerProps) => (
				<DatePickerCustomHeader
					{...headerProps}
					locale={language}
					ariaLabels={ariaLabels}
					enableMonthSelect={enableMonthSelect}
					enableYearSelect={enableYearSelect}
					yearOptions={yearOptions}
				/>
			)}
			customInput={<CustomInput {...props} customRef={inputRef} />}
			onChange={onChange}
			locale={language === 'da' ? da : null}
			dateFormat="dd/MM/yyyy"
			placeholderText={placeholder}
			selectsRange
			startDate={startDate}
			endDate={endDate}
		/>
	);
};
